import Link from "next/link";
import React from "react";
import BlogCard from "../BlogShowcase/BlogCard";

export default function EachBlogSection({ Blog, index, defaultView = -1 }) {
  if (defaultView === -1) {
    defaultView = Blog.blogList.length;
  }
  return (
    <>
      <div className="flex items-end justify-between">
        <div>
          <Link
            href={`blog/${Blog.categorySlug}/page/1`}
            className="text-3xl font-semibold"
          >
            {Blog.category}
          </Link>
        </div>
      </div>
      <div className="flex items-center justify-center">
        <div className="flex flex-wrap justify-center gap-6">
          {Blog.blogList.slice(0, defaultView).map((eachBlog, index) => {
            return (
              <BlogCard
                key={index}
                category={eachBlog.category}
                slug={eachBlog.slug}
                tags={eachBlog.tags}
                coverImage={eachBlog.coverImage}
                title={eachBlog.title}
                authorName={eachBlog.authorName}
                publishedOn={eachBlog.publishedOn}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
